import { browserHistory } from 'react-router';
import { store } from 'redux_store/configureStore';
import { syncHistoryWithStore } from 'react-router-redux';

export const history = syncHistoryWithStore(browserHistory, store); // eslint-disable-line import/prefer-default-export
